var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurposeBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 297.316,
    height: 239.938,
    viewBox: "0 0 297.316 239.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 297.316,
    height: 239.938,
    rx: 8.931,
    transform: "translate(858.566 1749.667)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2385",
    "data-name": "Rectangle 2385",
    width: 230.598,
    height: 230.598,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(-858.566 -1749.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2796",
    "data-name": "Group 2796",
    transform: "translate(925.281 1759.005)",
    opacity: 0.225
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2358",
    "data-name": "Rectangle 2358",
    width: 7.207,
    height: 7.207,
    transform: "translate(46.84 75.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2359",
    "data-name": "Rectangle 2359",
    width: 7.207,
    height: 7.207,
    transform: "translate(28.825 64.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2360",
    "data-name": "Rectangle 2360",
    width: 7.207,
    height: 7.207,
    transform: "translate(10.809 54.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2361",
    "data-name": "Rectangle 2361",
    width: 7.207,
    height: 7.207,
    transform: "translate(75.665 46.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2362",
    "data-name": "Rectangle 2362",
    width: 7.207,
    height: 7.207,
    transform: "translate(64.854 28.825)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2363",
    "data-name": "Rectangle 2363",
    width: 7.207,
    height: 7.207,
    transform: "translate(54.046 10.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2364",
    "data-name": "Rectangle 2364",
    width: 7.207,
    height: 7.207,
    transform: "translate(111.695 18.016)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2365",
    "data-name": "Rectangle 2365",
    width: 7.207,
    height: 7.207,
    transform: "translate(111.695 36.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2366",
    "data-name": "Rectangle 2366",
    width: 7.205,
    height: 7.207,
    transform: "translate(111.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2367",
    "data-name": "Rectangle 2367",
    width: 7.207,
    height: 7.207,
    transform: "translate(176.551 75.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2368",
    "data-name": "Rectangle 2368",
    width: 7.207,
    height: 7.207,
    transform: "translate(194.567 64.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2369",
    "data-name": "Rectangle 2369",
    width: 7.207,
    height: 7.207,
    transform: "translate(212.583 54.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2370",
    "data-name": "Rectangle 2370",
    width: 7.207,
    height: 7.207,
    transform: "translate(147.726 46.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2371",
    "data-name": "Rectangle 2371",
    width: 7.207,
    height: 7.207,
    transform: "translate(158.537 28.825)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2372",
    "data-name": "Rectangle 2372",
    width: 7.207,
    height: 7.207,
    transform: "translate(169.346 10.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2373",
    "data-name": "Rectangle 2373",
    width: 7.207,
    height: 7.207,
    transform: "translate(18.014 111.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2374",
    "data-name": "Rectangle 2374",
    width: 7.207,
    height: 7.207,
    transform: "translate(36.03 111.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2375",
    "data-name": "Rectangle 2375",
    width: 7.207,
    height: 7.205,
    transform: "translate(0 111.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2376",
    "data-name": "Rectangle 2376",
    width: 7.207,
    height: 7.207,
    transform: "translate(46.84 147.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2377",
    "data-name": "Rectangle 2377",
    width: 7.207,
    height: 7.207,
    transform: "translate(28.825 158.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2378",
    "data-name": "Rectangle 2378",
    width: 7.207,
    height: 7.207,
    transform: "translate(10.809 169.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2379",
    "data-name": "Rectangle 2379",
    width: 7.207,
    height: 7.207,
    transform: "translate(205.377 111.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2380",
    "data-name": "Rectangle 2380",
    width: 7.207,
    height: 7.207,
    transform: "translate(187.362 111.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2381",
    "data-name": "Rectangle 2381",
    width: 7.207,
    height: 7.205,
    transform: "translate(223.393 111.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2382",
    "data-name": "Rectangle 2382",
    width: 7.207,
    height: 7.207,
    transform: "translate(176.551 147.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2383",
    "data-name": "Rectangle 2383",
    width: 7.207,
    height: 7.207,
    transform: "translate(194.567 158.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2384",
    "data-name": "Rectangle 2384",
    width: 7.207,
    height: 7.207,
    transform: "translate(212.583 169.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2795",
    "data-name": "Group 2795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794",
    "data-name": "Group 2794",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M92.747,59.111A22.484,22.484,0,1,1,70.263,36.627,22.485,22.485,0,0,1,92.747,59.111",
    transform: "translate(45.037 34.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M106.263,63.625H53.987A16.66,16.66,0,0,0,37.319,80.273v90.351H54.433v-7.945H105.8v7.945H122.93V80.273a16.672,16.672,0,0,0-16.668-16.648M84.408,89.306H75.841V80.739h8.567Z",
    transform: "translate(35.178 59.974)",
    fill: "#fff"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurposeBg);
export default __webpack_public_path__ + "static/media/purpose-bg.977347a210e176a4ec1472252804010f.svg";
export { ForwardRef as ReactComponent };